'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var withAnalytics = require('../../withAnalytics.js');

var Tile = function (_a) {
    var children = _a.children; _a.analyticsEvents; var props = tslib.__rest(_a, ["children", "analyticsEvents"]);
    return (jsxRuntime.jsx("div", tslib.__assign({ "data-testid": "tile", className: "px-0 col-auto" }, props, { children: children })));
};
var exportComponent = withAnalytics.withAnalytics(Tile);
exportComponent.displayName = Tile.name;

exports.Tile = Tile;
exports.default = exportComponent;
//# sourceMappingURL=Tile.js.map
